<script lang="ts">
	import { confirm } from '$lib/stores/confirm.svelte';
	import { trapFocus } from '$lib/actions/trapFocus';

	let state = $derived(confirm.state);

	$effect(() => {
		if (!state.open) return;
		const onKey = (e: KeyboardEvent) => {
			if (e.key === 'Escape') confirm.cancel();
		};
		window.addEventListener('keydown', onKey);
		return () => window.removeEventListener('keydown', onKey);
	});
</script>

{#if state.open}
	<!-- svelte-ignore a11y_no_static_element_interactions -->
	<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
	<div class="fixed inset-0 z-[110] bg-ink/60 backdrop-blur-sm" aria-hidden="true"></div>
	<!-- svelte-ignore a11y_click_events_have_key_events -->
	<!-- svelte-ignore a11y_no_static_element_interactions -->
	<div
		use:trapFocus
		class="fixed inset-0 z-[110] flex items-center justify-center p-4"
		role="dialog"
		aria-modal="true"
		aria-labelledby="confirm-title"
		tabindex="-1"
		onclick={(e) => e.target === e.currentTarget && confirm.cancel()}
	>
		<div class="w-full max-w-md rounded border border-mist bg-paper shadow-overlay">
			<div class="space-y-2 px-6 pt-6 pb-4">
				<h2 id="confirm-title" class="font-display text-lg font-titre text-ink">{state.title}</h2>
				{#if state.body}
					<p class="text-sm leading-relaxed text-ash">{state.body}</p>
				{/if}
			</div>
			<footer class="flex items-center justify-end gap-2 border-t border-mist px-6 py-3">
				<button
					type="button"
					class="btn-relief-soft px-4 py-2 text-sm font-medium"
					onclick={() => confirm.cancel()}
				>
					{state.cancelLabel ?? 'Annuler'}
				</button>
				<button
					type="button"
					class="px-4 py-2 text-sm font-semibold {state.danger ? 'btn-relief-danger' : 'btn-relief'}"
					onclick={() => confirm.confirm()}
				>
					{state.confirmLabel ?? 'Confirmer'}
				</button>
			</footer>
		</div>
	</div>
{/if}
